module.exports = __webpack_public_path__ + "img/053-A.f3e22042.png";